module.exports = __webpack_public_path__ + "img/1.a9205f04.jpg";